/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Wiz_Kind_Series_DescInputs */



/**
* | output |
* | --- |
* | "Runs over weeks. Players join whenever they can and games start as soon as a table fills." |
*
* @param {Tournament_Wiz_Kind_Series_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_wiz_kind_series_desc = /** @type {((inputs?: Tournament_Wiz_Kind_Series_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Wiz_Kind_Series_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Se déroule sur plusieurs semaines. Les joueurs se joignent quand ils le peuvent et les parties démarrent dès qu'une table est complète.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Se prolonga durante semanas. Los jugadores se suman cuando pueden y las partidas empiezan en cuanto se llena una mesa.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Corre ao longo de semanas. Os jogadores entram quando podem e as partidas começam assim que uma mesa se completa.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Si svolge nell'arco di settimane. I giocatori si uniscono quando possono e le partite iniziano appena un tavolo è al completo.")
	return /** @type {LocalizedString} */ ("Runs over weeks. Players join whenever they can and games start as soon as a table fills.")
});